import type { DistributionPartnerUser } from '@common/api/graphql/getLoginUserGql';
import { useZendeskWidget } from '@common/hooks/useZendeskWidget';
import { hasGon } from '@common/lib/gon';
import type { Gon } from '@console/common/window';
import type { Theme } from '@mui/material';
import type { StyleRules, WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import { useEffect, useState } from 'react';

const styles = (theme: Theme): StyleRules => ({
  button: {
    minWidth: 140,
    position: 'fixed',
    bottom: 20,
    right: 20,
    // 以下は g4b マイページのボタンデザインと合わせるためのもの
    fontSize: 16,
    paddingTop: 12,
    paddingBottom: 12,
    borderRadius: 100,
    fontWeight: 'bold',
    borderColor: theme.palette.primary.main,
    backgroundColor: '#FFFFFF',
    borderWidth: 2,
    '&:hover': {
      borderWidth: 2
    }
  }
});

type OwnProps = WithStyles<typeof styles> & {
  distributionPartnerUser: DistributionPartnerUser;
};

const ZendeskWidget: React.FC<OwnProps> = ({}) => {
  const [zendeskWidgetAccountKey, setZendeskWidgetAccountKey] = useState<
    null | string
  >(null);
  useZendeskWidget(zendeskWidgetAccountKey);

  useEffect(() => {
    if (hasGon<Gon>(window)) {
      if (window.gon.zendeskWidgetAccountKey) {
        setZendeskWidgetAccountKey(window.gon.zendeskWidgetAccountKey);
      }
    }
  }, []);

  return null;
};

export default withStyles(styles)(ZendeskWidget);
